import { Grid } from "@mui/material";
import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import Select from "react-select";
import InputGroup from "../../../components/FormComponent/InputGroup";
import ReactQuill from "react-quill";
import { useEffect, useState } from "react";
import Button from "../../../components/Button";
import Preview from "./Preview";
import "./component.css";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import { useUserState } from "../../../context/UserContext";
import { useNavigate } from "react-router-dom";
const SendBulkEmail = () => {
  const { profile } = useUserState();
  const [messageContent, setMessageContent] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isScheduled, setIsScheduled] = useState(false);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [recipientList, setRecipientList] = useState(null);
  const [recipientListId, setRecipientListId] = useState("");
  const [subject, setSubject] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [templateId, setTemplateId] = useState(null);
  const [sendWith, setSendWith] = useState(null);
  const [showMailServiceSelect, setShowMailServiceSelect] = useState(false);
  const [template, setTemplate] = useState({});
  const [mailingSelect, setMailingSelect] = useState([]);
  const [selectedMailingService, setSelectedMailingService] = useState(null);
  const [emailUnitBalance, setEmailUnitBalance] = useState(0);
  const navigate = useNavigate();

  /**
   * Fetches subscriber data from the API and formats it for the recipient list.
   */
  const fetchSubscriberData = () => {
    httprequest
      .get("/api/v1/email-sub")
      .then((res) => {
        const formattedData = res.data.data.map(subscriber => ({
          value: subscriber.id,
          label: subscriber.name
        }));
        setRecipientList(formattedData);
      })
      .catch(() => {
      });
  };

  /**
 * Fetches email templates from the API and sets the template options state.
 */
  const fetchEmailTemplateData = () => {
    httprequest
      .get("/api/v1/email-temp")
      .then((res) => {
        setTemplateOptions(res.data.data);
      })
      .catch(() => {
      });
  };

  /**
   * Fetches a specific email template by its ID and updates the subject and message content.
   * @returns {void}
   */
  const fetchTemplateById = () => {
    httprequest
      .get(`/api/v1/email-temp/${templateId}`)
      .then((res) => {
        setSubject(res.data.data.title);
        setMessageContent(res.data.data.body);
        setTemplate(res.data.data);
      })
      .catch(() => {
      });
  };

  const fetchEmailUnitBalance = async () => {
    httprequest
      .get("/api/v1/email-sub/unit-balance")
      .then((res) => {
        setEmailUnitBalance(res.data.data);
      })
      .catch(() => {
      });
  };

  const handleEditorDrop = (event) => {
    if (
      event.dataTransfer &&
      event.dataTransfer.files &&
      event.dataTransfer.files.length > 0
    ) {
      // Prevent drop if it's a file (e.g., image)
      event.preventDefault();
      event.stopPropagation();
    }
  };
  const handlePaste = (event) => {
    const items = event.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      // Check if any pasted item is an image
      if (items[i].type.indexOf("image") !== -1) {
        event.preventDefault(); // Prevent the paste

        return;
      }
    }
  };

  // --| Quill text format is defined explicitly so as to avoid images and videos from being pasted
  const Quillformats = [
    "background",
    "bold",
    "color",
    "font",
    "code",
    "italic",
    "link",
    "size",
    "strike",
    "script",
    "underline",
    "blockquote",
    "header",
    "indent",
    "list",
    "align",
    "direction",
    "code-block",
    "formula"
    // 'image'
    // 'video'
  ];
  const handleQuillChange = (content) => {
    setMessageContent(content);
  };

  const handleCheckboxChange = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);

    if (newCheckedState) {
      setTemplateId(null);
      setTemplate({});
      setSubject("");
      setMessageContent("");
    }
  };

  const handleScheduleChange = () => {
    setIsScheduled(!isScheduled);
  };

  /**
   * Fetches the mailing options from the API.
   * Formats the options to be used in the select dropdown.
   * @returns {void}
   */
  const fetchMailingOptions = () => {
    httprequest
      .get("/api/v1/integrations/school?category=mail")
      .then((res) => {
        const formattedMailingOptions = res.data.data.map(option => ({
          value: option.id,
          label: option.provider
        }));
        setMailingSelect(formattedMailingOptions);
      })
      .catch(() => {
        toast.error("Failed to fetch mailing services.");
      });
  };

  /**
   *  Handles the sending of the email.
   *  Validates the required fields and sends the email using the selected template or freeform content.
   * @returns {void}
   */
  const handleSendEmail = () => {
    if (!templateId && !isChecked) {
      toast.error("Please select a template or enable freeform.");

      return;
    }
    if (!sendWith) {
      toast.error("Please select method to send email");

      return;
    }

    if (!recipientListId) {
      toast.error("Please select a recipient.");

      return;
    }

    setIsLoading(true);
    const payload = {
      template_id: templateId,
      sender_mail: profile?.email,
      sender_name: profile?.school_name,
      type: isChecked ? "freeform" : "email_template",
      send_with: sendWith,
      email_state: isScheduled ? "scheduled" : "outbox",
      subscriber_list_id: recipientListId,
      subject,
      body: messageContent,
      ...(sendWith === "mail_service" && { mail_provider_id: selectedMailingService }),
      ...(isScheduled && {
        schedule_date: scheduleDate,
        schedule_time: scheduleTime
      })
    };

    httprequest
      .post("/api/v1/bulk-email", payload)
      .then((res) => {
        toast.success(res.data.message);
        setTimeout(() => {
          navigate("/messaging/bulkmails");
        }, 1000);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleRecipientChange = (selectedOption) => {
    setRecipientListId(selectedOption ? selectedOption.value : "");
  };

  /**
   *  Handles the change of email template selection.
   *  Updates the template ID and fetches the template details.
   * @param {*} selectedOption  - The selected option from the template dropdown.
   * @returns {void}
   */
  const handleTemplateChange = (selectedOption) => {
    if (selectedOption) {
      setTemplateId(selectedOption.value);
      fetchTemplateById();
      setIsChecked(false);
    } else {
      setTemplateId(null);
      setTemplate({});
    }
  };

  /**
   * Fetches the template details by ID.
   * @description This function is called when the template ID is updated.
   * @param {*} e - The event object.
   */
  const handleEmailTokenChange = (e) => {
    if (e.target.checked) {
      setSendWith("email_token");
      setShowMailServiceSelect(false);
    } else {
      setSendWith(null);
    }
  };

  /**
   *  Handles the change of mailing service checkbox.
   * Updates the state to show or hide mailing service select options.
   * @param {*} e - The event object from the checkbox change.
   */
  const handleMailServiceChange = (e) => {
    if (e.target.checked) {
      setSendWith("mail_service");
      setShowMailServiceSelect(true);
    } else {
      setSendWith(null);
      setShowMailServiceSelect(false);
    }
  };

  /**
   *  Handles the selection of mailing service options.
   *  Updates the selected mailing service state.
   * @param {*} selectedOption
   */
  const handleMailService = (selectedOption) => {
    setSelectedMailingService(selectedOption ? selectedOption.value : null);
  };

  useEffect(() => {
    fetchEmailTemplateData();
    fetchSubscriberData();
    fetchMailingOptions();
    fetchEmailUnitBalance();
  }, []);

  useEffect(() => {
    if (templateId) {
      fetchTemplateById();
    }
  }, [templateId]);

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Send Bulk Emails"
            subtitle="You can send bulk emails here."
          />
          {/* <div className="token">
            <p>Email Token Balance</p>
            <h3>{emailUnitBalance}</h3>
          </div> */}
          <Grid container spacing={2} className="template">
            <Grid container lg={7} md={6} sm={12} xs={12} spacing={2}
              className="padding-white"
            >
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="multiple-select">
                  <p>
                    Email Template <span className="input-required">*</span>
                  </p>
                  <Select
                    name="template"
                    required
                    options={templateOptions.map((template) => ({
                      value: template?.id,
                      label: template?.title
                    }))}
                    onChange={handleTemplateChange}
                    closeMenuOnSelect={true}
                    value={templateId ? {
                      value: templateId,
                      label: templateOptions.find(t => t.id === templateId)?.title
                    } : null}
                  />
                </div>
              </Grid>
              <Grid item>
                <div className="border_bottom">
                  <input
                    type="checkbox"
                    name="custom_form"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <label className="checkbox-label" htmlFor="custom_form">
                    Send Freeform
                  </label>
                </div>
              </Grid>
              {isChecked ? (
                <>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      inputType="text"
                      label="Subject"
                      inputName="subject"
                      placeHolder="What is the subject of the mail"
                      required
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <p
                      style={{ fontWeight: 500, fontSize: "14px" }}
                      className="text-align-left no-margin-block"
                    >
                      Message
                      <span className="input-required">*</span>
                    </p>
                    <ReactQuill
                      theme="snow"
                      value={messageContent}
                      onDrop={handleEditorDrop}
                      onChange={handleQuillChange}
                      onPaste={handlePaste}
                      formats={Quillformats}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ["bold", "italic", "underline"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          ["clean"] // Remove the image button
                        ]
                      }}
                      style={{
                        borderRadius: 30,
                        textAlign: "left",
                        "& qlContainer": { height: "150px" }
                      }}
                    />
                  </Grid>
                </>
              ) : null}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="multiple-select">
                  <p>
                    Email Recipients
                    <span className="input-required"> * </span>
                  </p>
                  <Select
                    name="recipients"
                    options={recipientList}
                    onChange={handleRecipientChange}
                    required
                    closeMenuOnSelect={true}
                  />
                </div>
              </Grid>

              <p
                style={{ fontWeight: 500, fontSize: "14px", marginLeft: "1rem", marginTop: "1rem" }}
                className="text-align-left no-margin-block"
              >
                  Send With
              </p>
              <Grid container className="template_border input-padding">
                <div className="check">
                  <input type="checkbox" name="email_token" checked={sendWith === "email_token"}
                    onChange={handleEmailTokenChange}
                  />
                  <label className="checkbox-label" htmlFor="email_token">
                    Email token ({emailUnitBalance} units left)
                  </label>
                </div>
                <div className="check">
                  <input type="checkbox" name="mail_service"
                    checked={sendWith === "mail_service"}
                    onChange={handleMailServiceChange}
                  />
                  <label className="checkbox-label" htmlFor="mail_service">
                    Mailing service
                  </label>
                </div>
                {showMailServiceSelect && (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="multiple-select">
                      <Select
                        isMulti
                        name="recipients"
                        placeholder="Mailing Service"
                        required
                        closeMenuOnSelect={true}
                        options={mailingSelect}
                        onChange={handleMailService}
                      />
                    </div>
                  </Grid>
                )}
              </Grid>
              <Grid item>
                <div className="checks">
                  <input
                    id="schedule_form"
                    type="checkbox"
                    name="schedule_form"
                    checked={isScheduled}
                    onChange={handleScheduleChange}
                    className="custom-check"
                  />
                  <label className="check-label" htmlFor="schedule_form">
    Schedule for Later
                  </label>
                </div>
              </Grid>
              {isScheduled && (
                <Grid container spacing={2} className="padding_1rem input-padding">
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      inputType="date"
                      label="Select Date"
                      inputName="schedule_date"
                      onChange={(e) => setScheduleDate(e.target.value)}
                      inputMin={new Date().toISOString().split("T")[0]}
                      required
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      inputType="time"
                      label="Select Time"
                      inputName="schedule_time"
                      onChange={(e) => setScheduleTime(e.target.value)}
                      required
                    />
                  </Grid>
                </Grid>
              )}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Send Email"
                  isLoading={isLoading}
                  onClick={handleSendEmail}
                />
              </Grid>
            </Grid>

            {template && template.title && template.body && (
              <Grid item lg={5} md={6} sm={12} xs={12} className="padding-white no_margin">
                <p style={{ fontWeight: 500, fontSize: "14px", alignSelf: "flex-start", display: "flex" }}>
        Email Preview
                </p>
                <Preview Title={template.title} Body={template.body} />
              </Grid>
            )}
          </Grid>
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default SendBulkEmail;
